import { IViolationUpsertDto } from "../dtos/violation-upsert.dto";
import { IViolationDto } from "../dtos/violation.dto";

export const toViolationUpsertDto = ({
  problemType,
  problemId,
  rate,
}: IViolationDto): IViolationUpsertDto => ({
  problemType,
  problemId,
  rate,
});
